export default __webpack_public_path__ + "static/media/juice-fruit-product-r-desktop.c37936ce.png";